import { registerComponents } from '@/utils/component'
import appTitle from './appTitle.vue'
import appTable from './appTable.vue'
import appDetail from './appDetail.vue'
import appProgress from './appProgress.vue'
import appUpload from './appUpload.vue'
import appDescription from './appDescription.vue'

// components list below
const components = {
  appTitle,
  appTable,
  appDetail,
  appProgress,
  appUpload,
  appDescription
}

export default {
  install (Vue) {
    registerComponents(Vue, components)
  }
}
